if (!customElements.get('drp-spotlight-slider')) {
  customElements.define('drp-spotlight-slider', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.track = this.querySelector('.drp-spotlight-slider__track');
      this.slides = [...this.querySelectorAll('[data-spotlight-slide]')];
      const controls = [...this.querySelectorAll('.drp-spotlight-slider__controls')];
      if (!this.track || this.slides.length < 2 || !controls.length) return;
      this.prev = [...this.querySelectorAll('[data-spotlight-prev]')];
      this.next = [...this.querySelectorAll('[data-spotlight-next]')];
      this.count = [...this.querySelectorAll('[data-spotlight-count]')];
      controls.forEach(control => { control.hidden = false; });
      this.update = () => {
        const left = this.track.getBoundingClientRect().left;
        this.index = this.slides.reduce((best, slide, i) =>
          Math.abs(slide.getBoundingClientRect().left - left) <
          Math.abs(this.slides[best].getBoundingClientRect().left - left) ? i : best, 0);
        this.prev.forEach(button => { button.disabled = this.index === 0; });
        this.next.forEach(button => { button.disabled = this.index === this.slides.length - 1; });
        const label = (this.index + 1) + ' / ' + this.slides.length;
        this.count.forEach(count => { if (count.textContent !== label) count.textContent = label; });
      };
      this.go = (index) => {
        const slide = this.slides[Math.max(0, Math.min(index, this.slides.length - 1))];
        this.track.scrollBy({
          left: slide.getBoundingClientRect().left - this.track.getBoundingClientRect().left,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
      };
      this.prev.forEach(button => button.addEventListener('click', () => this.go(this.index - 1), options));
      this.next.forEach(button => button.addEventListener('click', () => this.go(this.index + 1), options));
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(this.update);
      }, { ...options, passive: true });
      this.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (index >= 0) this.go(index);
      }, options);
      this.resize = new ResizeObserver(this.update);
      this.resize.observe(this.track);
      this.update();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}
